export const CheckboxGroupWidgetId = 'CheckboxGroupWidget';

export enum CheckboxGroupWidgetAttributes {
  ITEMS = 'checkboxGroupItems',
}
